class CartItem {
	constructor(type) {
		this.type = type;
	}

	/**
	 * @param {CartItem} cartItem
	 * @return any
	 */
	updateData(cartItem) {}

	/**
	 * @param {CartItem} cartItem
	 * @return Boolean
	 */
	isMatched(cartItem) {
		return false
	}

	/**
	 * @return HTMLElement
	 */
	getHtmlCard(){
		return document.createElement('div')
	}

	/**
	 * @return string
	 */
	getTitle() {
		return '';
	}

	/**
	 * @return string
	 */
	getImageUrl() {
		return '';
	}

	/**
	 * @return string
	 */
	getType() {
		return '';
	}

	/** Get CartItem Id
	 *	@return Number|String
	 */
	getId() {
		return -1;
	}

	getTotal() {
		return 0;
	}

	toRequestPayloadForValidateItems() {
		return {}
	}
}

export default CartItem;